export default __webpack_public_path__ + "static/media/WIGGLE EX_OL-01.3f3b5c29.jpg";